import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { ReportService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { Stylist } from '../../models/stylist/stylist.model';
import { Utilities } from '../../utilities/utilities';
import { SMPickerRange } from '../../components/smr-date-picker/smr-date-picker.component';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
import { ChartsService } from '../../services/charts.service';
import { Router } from '@angular/router';

// import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics';
import { ExportTableService } from '../../services/export-table.service';
import { CalendarService } from '../../services/calendar.service';
import 'chart.piecelabel.js';
import { ChartConfiguration,ChartType, ChartTypeRegistry } from 'chart.js';

interface IRow {
  timestamp: string;
  booked: number;
  timeoff: number;
  totalWorkingHours: number;
  productivity: number;
}
interface primeNgCol {
  field: string;
  header: string;
}
type MyChartTypeRegistry = {
  bar: ChartType;
  line: ChartType;
  radar: ChartType;
  pie: ChartType;
  // ... other chart types
};
@Component({
  selector: 'app-productivity-report',
  templateUrl: './productivity-report.page.html',
  styleUrls: ['./productivity-report.page.scss'],
})
export class ProductivityReportPage implements OnInit {
  //@ViewChild(Content) content: Content;

  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;

  public stats: Array<IRow>;

  public cols: primeNgCol[];

  public stylistID: number;

  public stylist: Stylist;

  public yearIndicator: boolean = false;

  public xAxisDateChanger: string;

  public readOnlyStylistPicker: boolean;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public errorOccurredWhileLoadingStats: boolean;

  public startDate: Date;

  public endDate: Date;

  public groupBy: string;

  public yearTotalWeekData: any[] = [];

  public lineChartLabels: Array<string> = [];

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    labels: this.lineChartLabels,
    datasets: [
      {
        data: [],
        label: 'Productivity',
        backgroundColor: `rgba(121, 130, 185, 0.2)`,
        borderColor: `rgba(121, 130, 185, 1)`,
        pointBackgroundColor: `rgb(121, 130, 185, 1)`,
        pointBorderColor: 'rgba(51, 51, 51, 0.6)',
        pointHoverBackgroundColor: '#fff',
        tension: 0.5
      },
    ],
  };

  private readonly tooltipCallbacks: object;

  public lineChartType: keyof MyChartTypeRegistry = 'line';

  public lineChartOptions: any;

  public pieChartLabels: string[] = ['Productive', 'Booked off', 'Not booked'];

  public pieChartData: ChartConfiguration<'pie'>['data'] = {
    labels: this.pieChartLabels,
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: ['#7982B9', '#A5C1DC', '#E9F6FA'],
        borderColor: ['#333', '#333', '#333'],
      },
    ],
  };
  public pieChartType: keyof MyChartTypeRegistry = 'pie';

  public pieChartOptions: Object;

  constructor(
    //public navCtrl: NavController,
    //public navParams: NavParams,
    public reportService: ReportService,
    public userService: UserService,
    public alertController: AlertController,
    public loadingCtrl: LoadingController,
    private ExportTableService: ExportTableService,
    private CalendarService: CalendarService,
    private ChartsService: ChartsService,
    private router: Router // , // private googleAnalytics: GoogleAnalytics
  ) {
    this.stats = [];
    this.cols = [
      { field: 'timestamp', header: 'Date' },
      { field: 'booked', header: 'Booked' },
      { field: 'productivity', header: 'Productivity' },
    ];

    this.tooltipCallbacks = ChartsService.tooltipCallbackFunction(
      this.yearTotalWeekData
    );
     this.lineChartOptions = ChartsService.lineChartOption(
       this.yearTotalWeekData,
       this.xAxisDateChanger
     );
    this.lineChartOptions.scales.y = 
      {
        ticks: {
          callback: function (value, index, values) {
            return value + '%';
          },
        },
      }
    
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      this.readOnlyStylistPicker = !(
        user.isAdministrator() ||
        user.getCanViewReports() === 1 ||
        user.getViewAllClients() === 1
      );
    }
  }

 
  public ngOnInit() {
    // this.googleAnalytics.trackView('ProductivityReportPage')
    //   .then(() => {
    //   })
    //   .catch(() => {
    //   });
    if (!this.startDate) {
      let dateFromCache: string = localStorage.getItem('datePickerStartDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.startDate = Utilities.parseDate(dateFromCache);
      }
    }

    if (!this.endDate) {
      let dateFromCache: string = localStorage.getItem('datePickerEndDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.endDate = Utilities.parseDate(dateFromCache);
      }
    }

    if (!this.groupBy) {
      let dateFromCache: string = localStorage.getItem('groupBy');

      if (dateFromCache) {
        this.groupBy = dateFromCache;
      } else {
        this.groupBy = 'daily';
      }
    }
  }

  public ngAfterViewInit() {
    if (this.stylist) {
      this.loadStats(this.stylist, this.startDate, this.endDate, this.groupBy);
    }
  }

  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
    }
  }

  public onStylistSelect(stylist: Stylist) {
    this.isLoading = false;
    if (stylist) {
      this.stylistID = stylist.getID();
      this.stylist = stylist;
      this.loadStats(stylist, this.startDate, this.endDate, this.groupBy);
    }
  }

  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.errorOccurredWhileLoadingStats = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public rangeChanged(dateRange: SMPickerRange) {
    this.startDate = dateRange.start;
    this.endDate = dateRange.end;
    this.groupBy = dateRange.groupBy;
    this.timeManager(dateRange.start, dateRange.end, this.groupBy);
    this.loadStats(this.stylist, this.startDate, this.endDate, this.groupBy);
  }

  public loadStats(
    stylist: Stylist,
    startDate: Date,
    endDate: Date,
    groupBy: string = 'daily'
  ) {
    this.timeManager(startDate, endDate, groupBy);
    this.isLoading = true;
    this.errorOccurredWhileLoadingStats = false;
    this.pieChartData.datasets[0].data = [];
    this.reportService
      .loadProductivity(stylist.id, startDate, endDate, groupBy)
      .subscribe({
        next: (rows) => {
          const stats: Array<IRow> = [];
          let lineChartProductivity: Array<number> = [];
          let lineChartLabels: Array<string> = [];
          let bookedTotal: number = 0;
          let timeoffTotal: number = 0;
          let workingHoursTotal: number = 0;

          rows.forEach((row) => {
            let productivity = 0;

            if (row.totalWorkingHours > 0) {
              productivity = Utilities.roundTo2Decimal(
                (row.booked / row.totalWorkingHours) * 100
              );
            } else {
              // productivity = Utilities.roundTo2Decimal(row.booked * 100);
              if (row.booked > 0) {
                productivity = 100;
              }
            }

            let timestamp: string = '';

            if (this.groupBy === 'daily') {
              timestamp = Utilities.formatDate(
                Utilities.parseDate(row.timestamp),
                'ddd, MMMM D, Y'
              );
            } else if (this.groupBy === 'weekly') {
              timestamp = row.timestamp;
            } else if (this.groupBy === 'monthly') {
              timestamp = Utilities.formatDate(
                Utilities.parseDate(row.timestamp),
                'MMMM'
              );
            }

            stats.push({
              timestamp: timestamp,
              booked: row.booked,
              timeoff: row.timeoff,
              totalWorkingHours: row.totalWorkingHours,
              productivity: Math.round(productivity),
            });
            lineChartProductivity.unshift(Math.round(productivity));
            lineChartLabels.unshift(timestamp);

            bookedTotal += row.booked;
            timeoffTotal += row.timeoff;
            workingHoursTotal += row.totalWorkingHours;
          });

          lineChartLabels.reverse()
          lineChartProductivity.reverse()

          let overallBookedPercentage: number = 0;
          let overallTimeOffPercentage: number = 0;
          let overallNotBooked: number = 0;

          if (workingHoursTotal > 0) {
            overallBookedPercentage = Utilities.roundTo2Decimal(
              (bookedTotal / workingHoursTotal) * 100
            );
            overallTimeOffPercentage = Utilities.roundTo2Decimal(
              (timeoffTotal / workingHoursTotal) * 100
            );
            overallNotBooked =
              100 - (overallBookedPercentage + overallTimeOffPercentage);
          } else {
            if (overallBookedPercentage > 0) {
              overallBookedPercentage = 100;
            }
          }

          this.pieChartData.datasets[0].data = [
            overallBookedPercentage,
            overallTimeOffPercentage,
            overallNotBooked,
          ];

          this.stats = stats;

          if (this.yearIndicator && groupBy === 'daily') {
            this.lineChartData.datasets[0].data = [];
            this.lineChartLabels = lineChartLabels.filter((label, i) => {
              return (i % 7 === 1 && i !== 1) || i === 0;
            });
            let dataSum: number = 0,
              count: number = 0;
            lineChartProductivity.forEach((val, i, array) => {
              if ((i !== 1 && i % 7 === 1) || i === array.length - 1) {
                this.lineChartData.datasets[0].data.push(
                  Number((dataSum / count).toFixed(2))
                );
                this.yearTotalWeekData.push({
                  sum: dataSum,
                  avg: Number((dataSum / count).toFixed(2)),
                });
                dataSum = 0;
                count = 0;
              } else {
                dataSum += val;
                count += 1;
              }
            });
          } else {
            this.yearTotalWeekData = [];
            this.lineChartLabels = lineChartLabels;
            this.lineChartData.datasets[0].data = lineChartProductivity;
            if (groupBy === 'weekly') {
              this.lineChartLabels = this.lineChartLabels.map((week) => {
                return week.substring(0, week.indexOf(' '));
              });
            } else if (groupBy === 'monthly') {
              this.lineChartLabels = this.lineChartLabels
                .map((month, i) => {
                  return (
                    this.startDate.getFullYear() +
                    '-' +
                    ('0' + (i + 1)).slice(-2) +
                    '-' +
                    '01'
                  );
                })
                .reverse();
            }
          }

          this.lineChartData.labels = this.lineChartLabels
          this.isLoading = false;
          //this.content.resize();
        },
        error: (e) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingStats = true;
          //this.content.resize();
        },
      });
  }

  public timeManager(dateRangeStart, dateRangeEnd, groupBy) {
    let resObj = this.CalendarService.timeManager(dateRangeStart, dateRangeEnd);
    this.xAxisDateChanger = resObj.xAxisDateChanger;
    this.yearIndicator = resObj.yearIndicator;

    // this.lineChartOptions.scales.xAxes[0].time.unit = this.xAxisDateChanger;
    // this.lineChartOptions.scales.xAxes[0].time.displayFormats =
    //   ChartsService.timeDisplayFormat();
    // if (this.yearIndicator && groupBy === 'daily') {
    //   this.lineChartOptions.tooltips.callbacks = this.tooltipCallbacks;
    // } else {
    //   this.lineChartOptions.tooltips.callbacks = {};
    // }
  }

  public exportPdf() {
    this.ExportTableService.exportPdf(
      this.stats.map((stat) => {
        return {
          timestamp: stat.timestamp,
          booked: stat.booked + ' of ' + stat.totalWorkingHours + ' hours',
          productivity: stat.productivity,
        };
      }),
      'Productivity',
      this.cols
    );
  }

  public exportExcel() {
    this.ExportTableService.exportExcel(
      this.stats.map((stat) => {
        return {
          timestamp: stat.timestamp,
          booked: stat.booked + ' of ' + stat.totalWorkingHours + ' hours',
          productivity: stat.productivity,
        };
      }),
      'Productivity',
      this.cols.map((col) => col.header)
    );
  }

  public onBack() {
    //this.navCtrl.pop();
    this.router.navigateByUrl('/reports');
  }
}
